// @flow

import React from "react";
import "./PayPalButton.scss";
import type {PayPalCancelResponse} from "../../../api/PayPalApi";
import {PayPalApproveResponse} from "../../../api/PayPalApi";
import {useTranslation} from "react-i18next";
import usePayPalScript from "../../../hooks/usePayPalScript";
import Spinner from "react-spinkit";

interface PayPalButtonProps {
	fundingSource: string;
    payPalPaymentRef: string;
    paymentMethod: string;
    onCreateOrder: () => void;
    onPaymentSuccess: (reference: string) => void;
    onPaymentCancelled: () => void;
    onPaymentError: () => void;
    // asked on the click: whether all is there to pay (the consent); no, and PayPal opens nothing
    canPay?: () => boolean;
}

const PayPalButton = (props: PayPalButtonProps) => {

    const {t} = useTranslation();
    const {PayPalButton, scriptResolved, hasError} = usePayPalScript("authorize");

    const onCreateOrder = () => {
        props.onCreateOrder();
        return props.payPalPaymentRef;
    }

	const onError = (err) => {
		console.error("paypal error: ", err);
		props.onPaymentError(props.paymentMethod);
	}

	const onCancel = (data: PayPalCancelResponse) => {
        console.error(t("cart.paymentMethods.paymentWindowClosed"));
		alert(t("cart.paymentMethods.paymentWindowClosed"));
        props.onPaymentCancelled(data.orderID);
	};

    const onApprove = (response: PayPalApproveResponse) => {
        props.onPaymentSuccess(response.paymentID);
    };

    const onClick = (_data, actions) => {
        return (props.canPay && !props.canPay()) ? actions.reject() : actions.resolve();
    };

    if(hasError) {
        console.error("PayPalButton, scriptResolved but has error, cannot render Button");
    }

    return (
        <>
        {(scriptResolved && !hasError) ? <PayPalButton
                    fundingSource={props.fundingSource || "paypal"}
                    onClick={onClick}
                    createOrder={onCreateOrder}
                    onApprove={onApprove}
                    onCancel={onCancel}
                    onError={onError}
                    style={{ layout: "horizontal", label: "pay", shape: "pill" }}
                />
                :<div style={{ display: "flex", justifyContent: "center" }}>
                {!hasError &&
                    <Spinner name="ball-beat" className="hpm-spinnerButton"/>
                }
                </div>}
        </>
    );
}

export default PayPalButton;
